// FORM INPUT LOGIC
import { scrollTo } from 'JBPlugin/scroll-to';
import { fieldLogic } from 'JBSrc/field-logic';

jQuery($ => {
	const $searchFilterInput = $('input[name="filter[keywords]"]');
	const $builderForm = $('.builder-form');
	const $tabbedBuilderForm = $('.tabs__content .builder-form');
	const $updateInterestsForm = $('#updateInterestsForm form');
	const $searchCards = $('#searchCards');
	const $searchLinks = $('#searchLinks');
	let hash;

	//When a dropdown menu is open, allow clicks inside it (eg. event date picker forms)
	$('.btn-group .dropdown-menu').on('click', "*", function(e) {
        e.stopPropagation();
    });

	//On Esc key, when there is a search for keywords
	$(document).keyup(function(e){
	    if ($searchFilterInput.length && ($searchFilterInput.is(':focus') || $searchFilterInput.val() != '') && e.key === "Escape") { // escape key maps to keycode `27`
	        $searchFilterInput.val('');
			$searchFilterInput.closest('form').submit();
	    }
	});

	//Check for builder form alerts
	if($builderForm.find('.alert-success').length){
		scrollTo('.builder-form .alert-success');
	}
	if($builderForm.find('.alert-danger').length){
		scrollTo('.builder-form .alert-danger');
	}
	if($tabbedBuilderForm.find('.alert-success').length){
		hash = $tabbedBuilderForm.find('.alert-success').closest('.tabs__content').attr('id');
		window.location.hash = '#' + hash;
		setTimeout(function(){
			scrollTo('.tabs__content .builder-form .alert-success');
		}, 750);
	}
	if($tabbedBuilderForm.find('.alert-danger').length){
		hash = $tabbedBuilderForm.find('.alert-danger').closest('.tabs__content').attr('id');
		window.location.hash = '#' + hash;

		setTimeout(function(){
			scrollTo('.tabs__content .builder-form .alert-danger');
		}, 750);
	}



	//Allow user interests to be cleared
	if($updateInterestsForm.length){
		$updateInterestsForm.submit(function(e){
			if($('.user-club-interest:checked').length === 0){
				$updateInterestsForm.append('<input type="hidden" name="clubs" value="" />');
			}
		});
	}

	//check for search cards
	if($searchCards.length){
		let searchcount = parseInt($searchCards.find('.card').length) + parseInt($searchLinks.find('.searched-pages .link-list__item').length);
		if(searchcount === 0 ){
			$searchCards.after('<p>Sorry, we couldn\'t find any search results for "' + $('#search-keywords').val() + '". Please try another search.</p>');
			$searchLinks.find('.searched-pages').remove();
		}
	}

	fieldLogic();
});
